import React, { useEffect, useState } from "react";
import ReBiddingDialog from "../../molecules/ReBiddingDialog";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import { editBids } from "../../../utils/API/editBid";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { taxationAmount } from "../../../utils/API/taxationAmount";

const EditDialog = ({
  open,
  onOk,
  onCancel,
  selectedRowData,
  selectedColumns,
  bidId,
}) => {
  const dispatch = useDispatch();
  const [noOfCredits, setNoOfCredits] = useState(null);
  const [pricePerCredit, setpricePerCredit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [remittance, setRemittance] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  if (!selectedRowData) {
    return null;
  }
  const previousNoOfCredits = selectedRowData["No. of credits"];
  const previousPricePerCredit = selectedRowData["Bid Price"];

  const handleOk = async () => {
    try {
      setLoading(true);
      await editBids(
        bidId,
        {
          noOfCredits: noOfCredits,
          bidAmount: pricePerCredit,
        },
        dispatch
      );
      setNoOfCredits("");
      setpricePerCredit("");
      onOk();
    } catch (error) {
      console.error("Error editing bid:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchTaxationData = async () => {
    try {
      const formData = {
        buyerOrigin: "NAT",
        sellerOrigin: "NAT",
        totalAmount: noOfCredits * pricePerCredit,
      };
      const amounts = await taxationAmount(formData, dispatch);
      setAmount(formData.totalAmount);
      setGst(amounts.data.data.tax);
      setPlatformFee(amounts.data.data.platform_fee);
      setRemittance(amounts.data.data.remittance);
      const calculatedTotalAmount =
        formData.totalAmount +
        amounts.data.data.tax +
        amounts.data.data.platform_fee +
        amounts.data.data.remittance;
      setTotalAmount(calculatedTotalAmount);
    } catch (error) {
      // toast.error("Error in Fetching Taxes and amounts Balance");
    } finally {
    }
  };
  // eslint-disable-next-line
  useEffect(() => {
    if (
      noOfCredits &&
      pricePerCredit &&
      noOfCredits !== "" &&
      pricePerCredit !== "" &&
      noOfCredits !== 0 &&
      pricePerCredit !== 0
    ) {
      fetchTaxationData();
    } else {
      setAmount(0);
      setGst(0);
      setPlatformFee(0);
      setRemittance(0);
      setTotalAmount(0);
    }
  }, [noOfCredits, pricePerCredit]);

  const handleCreditsChange = (e) => {
    const value = Math.max(
      0,
      Math.min(previousNoOfCredits, parseInt(e.target.value, 10))
    );
    setNoOfCredits(value);
  };

  const handlePriceChange = (e) => {
    const value = Math.max(0, Number(e.target.value));
    setpricePerCredit(value)
  };

  return (
    <ReBiddingDialog
      open={open}
      title={"ReBid"}
      onOk={handleOk}
      onCancel={onCancel}
      selectedRowData={selectedRowData}
      selectedColumns={selectedColumns}
    >
      <div className="pt-6">
        {/* Previous Bid Section */}
        <div className="flex pt-2 pr-10 text-base pb-2 gap-x-16">
          <div className="w-36 pl-10 font-bold ">Previous Bid-</div>
          <div className="flex gap-x-32">
            <div>No of Credits - {previousNoOfCredits}</div>
            <div className="pl-2">
              Price per credit - ${previousPricePerCredit}
            </div>
          </div>
        </div>

        {/* New Bid Section */}
        <div className="flex font-bold pt-2 pr-10 text-base bg-blue-400  ">
          <div className="w-48 pl-10 ">New Bid-</div>
          <div className="flex ml-4 gap-x-20 ">
            <div className="flex">
              <span className="text-base  pr-2 font-bold">
                No of Credits -{" "}
              </span>
              <Input
                type="number"
                variant="secondary"
                className="inline-block text-base w-16"
                value={noOfCredits}
                onChange={handleCreditsChange}
                placeholder={0}
                // min={0}
              />
            </div>
            <div className="flex">
              <span className="text-base font-bold  pr-2">
                {" "}
                Price per credit -
              </span>
              <Input
                type="number"
                variant="secondary"
                className="inline-block text-base w-14 "
                value={pricePerCredit}
                // onChange={handlePriceChange}
                onChange={(e) => setpricePerCredit(e.target.value)}
                // min={0}
              />
            </div>
          </div>
        </div>

        {/* Calculation Section */}
        <div className=" pl-12 pt-3 text-xs text-gray-400">
          <p className="py-1">Amount = ${amount?.toFixed(2)}</p>
          <p className="pb-1">Taxes(GST) = ${gst?.toFixed(2)}</p>
          <p className="pb-1">Remittance = ${remittance?.toFixed(2)}</p>
          <p className="pb-1">Platform Fee = ${platformFee?.toFixed(2)}</p>
        </div>
        <p className="pl-12 text-sm">
          Total Fund Required - ${totalAmount?.toFixed(2)}
        </p>
      </div>

      <div className="flex justify-center gap-5">
        <Button
          varient="primary"
          borderColor="blue"
          className="w-[9.375rem] h-10 mt-4 mb-7 text-base justify-center text-white font-bold border-none bg-blue-800 "
          onClick={handleOk}
        >
          <div className="flex justify-center">
            {loading ? <LoadingOutlined /> : " Re-Bid"}
          </div>
        </Button>
      </div>
    </ReBiddingDialog>
  );
};

export default EditDialog;
